var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"lingua-indigena","rota-base":"/admin/lingua-indigena","titulo-singular":"Língua Indígena","campos-extras":[{"campo":"codigo_inep","label":"Código INEP","tipo":"string","maxLength":10}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }